import React from "react";
import "./TopUpMinemi.css";

const TopUpMinemi = () => {
  return (
    <>
      <div id="top-up-minemi" className="bg-transparent ">
        <div id="list-of-documents-container">
          <div id="documents-content" className="bg-transparent">
            <div className="documents-content-container bg-transparent">
              <div className="content-box w-100 bg-transparent ">
                {" "}
                <div className="documents-text-box bg-transparent">
                  <div className="bg-transparent">
                    <div id="choose-minemi-head-box" className="bg-transparent">
                      <div className="choose-minemi-heading bg-transparent">
                        <h4 id="documents-heading" className="bg-transparent">
                          Why Transfer Your Loan and Get a Top-Up With MinEMI?
                        </h4>
                      </div>
                    </div>

                    <div className="text-box bg-transparent">
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent m-0">
                          Lower your EMI by transferring to a lower interest
                          rate.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent m-0">
                          Access additional funds for personal or business
                          needs.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent m-0">
                          One simple loan instead of multiple loans to manage.
                        </p>
                      </div>
                      <div className="d-flex flex-row gap-3 gap-md-5 bg-transparent">
                        <p className="symbol-para bg-transparent">#</p>
                        <p className="text-para bg-transparent m-0">
                          No need for a fresh application leverage your existing
                          loan.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="documents-image-box d-none d-md-block">
                  <div>
                    <img
                      className="documents-image"
                      src={Image}
                      alt="docuents-image"
                    />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopUpMinemi;
